import { FullscreenBar } from "@shopify/polaris"
import { Observer, observer } from "mobx-react"
import { validateV2 } from "polaris-enhance"
import { useHistory } from "react-router-dom"

import { useSaveBar, useUnsavedModal } from "@/common/hooks"
import TempFullBar from "@/components/TempFullBar/TempFullBar"
import stores from "@/stores"
import { isShopifyEnv } from "@/utils/env-helper"
import PopupsUtils from "@/utils/PopupsUtils"

function CustomFullscreenBar() {
  const { UserInfoStore, CommonStore, ReturnPageStore } = stores
  const { push } = useHistory()

  // 过审调整 start

  const onDiscardAction = () => {
    const defaultConfig = PopupsUtils.getInitOptions()
    PopupsUtils.destroyListener(true) // 先销毁监听器
    ReturnPageStore.setConfig(defaultConfig)
    PopupsUtils.registerListener() // 最后再注册监听器
  }
  const onSaveAction = () => {
    if (!validateV2()) return
    PopupsUtils.saveLoginConfig({ CommonStore, ReturnPageStore, UserInfoStore })
  }

  const handleGoBack = () => {
    push("/return-page")
  }

  const { node } = useSaveBar({
    onSave: onSaveAction,
    onDiscard: onDiscardAction,
    saving: CommonStore.popupSaveBtn.loading,
    isChanged: CommonStore.popupSaveBtn.active,
    confirmDisabled: !CommonStore.popupSaveBtn.active,
  })
  const { promptDom } = useUnsavedModal({
    isChanged: CommonStore.popupSaveBtn.active,
    discard: onDiscardAction,
  })

  return (
    <Observer>
      {() => {
        return (
          <>
            {!isShopifyEnv && (
              <FullscreenBar
                onAction={function (): void {
                  handleGoBack()
                }}
              />
            )}
            <TempFullBar backUrl="/return-page" />
            {promptDom}
            {node}
          </>
        )
      }}
    </Observer>
  )
}

export default observer(CustomFullscreenBar)
